import { useScrollAnimation } from './useScrollAnimation';

// Re-export the new hook for backward compatibility
export const useFadeInAnimation = (options) => {
  console.warn('useFadeInAnimation is deprecated. Use useScrollAnimation with type: "fade" instead.');
  return useScrollAnimation({ ...options, type: 'fade' });
};

export const useStaggerAnimation = (options) => {
  console.warn('useStaggerAnimation is deprecated. Use useScrollAnimation with type: "stagger" instead.');
  return useScrollAnimation({ ...options, type: 'stagger' });
};

// Export the new hook as the main export
export { useScrollAnimation };

export default useScrollAnimation;
